import React from "react";
import { Modal } from "react-bootstrap";
import "./SpotSelectionModal.css";

const SpotSelectionModal = ({ show, onHide, venues, onSelectSpot, onCreateSpot }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="lg"
            className="premium-modal spot-selection-modal"
        >
            <div className="modal-glass-container animate-fade-in">
                <div className="modal-glass-header">
                    <h2 className="modal-glass-title">Seleciona o teu Spot</h2>
                    <p className="modal-glass-subtitle">Para que local queres criar o evento?</p>
                    <button className="btn-close-premium" onClick={onHide}>
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                </div>

                <Modal.Body className="modal-glass-body p-4">
                    <div className="spots-grid">
                        {venues.map((venue, index) => (
                            <div
                                key={venue.id}
                                className="spot-selection-card animate-slide-up"
                                style={{ animationDelay: `${index * 0.1}s` }}
                                onClick={() => onSelectSpot(venue)}
                            >
                                <div className="spot-card-icon">
                                    <i className="fa-solid fa-location-dot"></i>
                                </div>
                                <div className="spot-card-info">
                                    <h4 className="spot-card-name">{venue.name}</h4>
                                    <span className="spot-card-type">{venue.type || "Estabelecimento"}</span>
                                </div>
                                <div className="spot-card-arrow">
                                    <i className="fa-solid fa-chevron-right"></i>
                                </div>
                            </div>
                        ))}

                        <div
                            className="spot-selection-card create-new animate-slide-up"
                            style={{ animationDelay: `${venues.length * 0.1}s` }}
                            onClick={onCreateSpot}
                        >
                            <div className="spot-card-icon">
                                <i className="fa-solid fa-plus"></i>
                            </div>
                            <div className="spot-card-info">
                                <h4 className="spot-card-name">Adicionar Novo Spot</h4>
                                <span className="spot-card-type">Regista um novo local</span>
                            </div>
                            <div className="spot-card-arrow">
                                <i className="fa-solid fa-chevron-right"></i>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </div>
        </Modal>
    );
};

export default SpotSelectionModal;
